import moment from 'moment'
import store from '@/store'

moment.locale('ru')

export default {
  methods: {
    getEventTitle(event) {
      if (event === null) {
        return ''
      }

      const datetime = moment(event.datetime)
      return `${event.name} ${event.additional_name || ''} (${datetime.format('D MMMM, dddd, HH:mm')})`
    },

    widgetFormatDate(datetime) {
      return `${moment(datetime).format('D MMMM, dddd, HH:mm')}`
    },

    formatMoney(amount, currency) {
      return new Intl.NumberFormat('ru-RU', { style: 'currency', currency: currency.toUpperCase() }).format(amount)
    },

    formatDate(datetime, format = 'DD/MM/YYYY HH:mm') {
      return moment(datetime).format(format)
    },

    formatDateUTC(datetime, format = 'DD/MM/YYYY HH:mm') {
      return moment.utc(datetime).format(format)
    },

    truncateText(text, maxLength) {
      if (text.length > maxLength) {
        return `${text.substring(0, maxLength)}…`
      }
      return text
    },

    paymentTypeNames(type) {
      return {
        cash: 'Наличные',
        card: 'Банковская карта',
        cashless: 'Безналичный расчет',
        bank_transfer: 'Банковский перевод',
        online: 'Онлайн оплата',
        other: 'Другое',
        checking_account: 'Расчетный счет',
      }[type]
    },

    statuses() {
      return {
        created: {
          name: 'Ожидает оплаты',
          variant: 'warning',
        },
        payed: {
          name: 'Оплачен',
          variant: 'success',
        },
        cancelled: {
          name: 'Отменен',
          variant: 'danger',
        },
        booked: {
          name: 'Забронирован',
          variant: 'primary',
        },
        sold: {
          name: 'Продан',
          variant: 'success',
        },
        returned: {
          name: 'Возвращен',
          variant: 'secondary',
        },
        issued: {
          name: 'Выдан',
          variant: 'secondary',
        },
        selling: {
          name: 'Реализация',
          variant: 'secondary',
        },
        printed: {
          name: 'Напечатан',
          variant: 'secondary',
        },
        completed: {
          name: 'Выполнен',
          variant: 'secondary',
        },
        executed: {
          name: 'Выполнен',
          variant: 'secondary',
        },
        registered: {
          name: 'Зарегистрирован',
          variant: 'secondary',
        },
        invitation: {
          name: 'Приглашенный',
          variant: 'secondary',
        },
        free: {
          name: 'Свободно',
          variant: 'secondary',
        },
        revoked: {
          name: 'Аннулирован',
          variant: 'danger',
        },
        blocked: {
          name: 'заблокирован',
          variant: 'dark',
        },
      }
    },

    getOrderStatusVariant(status) {
      const statuses = this.statuses()
      if (status === undefined) return 'secondary'
      if (!statuses.hasOwnProperty(status)) return 'secondary'
      return statuses[status].variant || 'secondary'
    },

    getOrderStatusName(status) {
      const statuses = this.statuses()
      if (status === undefined) return status
      if (!statuses.hasOwnProperty(status)) return status
      return statuses[status].name || status
    },

    numWord(value, words) {
      value = Math.abs(value) % 100
      const num = value % 10
      if (value > 10 && value < 20) return words[2]
      if (num > 1 && num < 5) return words[1]
      if (num === 1) return words[0]
      return words[2]
    },

    vSelectOnSearch(q, loading, type, update, params = {}) {
      if (q.length) {
        loading(true)
        const payload = { q, type, ...params }
        store.dispatch('api/fetchSelectOptions', payload).then(response => {
          const newList = []
          response.data.forEach(item => {
            newList.push(item)
          })
          update(newList)
          loading(false)
        })
      }
    },
  },
}
